import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { formatTRY } from "@/lib/format";

export function DevredenDialog({ onClose }) {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/dashboard/devreden").then(({ data }) => setD(data)); }, []);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="devreden-dialog">
        <DialogHeader><DialogTitle>Devreden Bakiye</DialogTitle>
          <DialogDescription>BizimHesap açılış borçlarının tahsilatlarla (önce en eski) kapanmamış kısmı. Vadesi geçmiş hesabına girmez.</DialogDescription></DialogHeader>
        <div className="text-[13px]" data-testid="devreden-summary">{d ? `${d.count} cari · toplam ${formatTRY(d.total)}` : "Yükleniyor…"}</div>
        <div className="max-h-[60vh] overflow-auto border rounded">
          <table className="erp-table text-[12px]"><thead><tr><th>Kod</th><th>Cari</th><th>Temsilci</th><th className="text-right">Devreden</th><th className="text-right">Cari Bakiye</th></tr></thead>
            <tbody>{(d?.items || []).map((r) => (
              <tr key={r.customer_id} className="cursor-pointer hover:bg-slate-50" onClick={() => nav(`/cariler/${r.customer_id}`)} data-testid={`devreden-row-${r.code}`}>
                <td className="font-mono">{r.code}</td><td className="max-w-[300px] truncate">{r.title}</td><td>{r.rep_name}</td>
                <td className="text-right font-mono font-semibold">{formatTRY(r.devreden)}</td><td className="text-right font-mono">{formatTRY(r.balance)}</td></tr>))}</tbody></table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
